import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/aggregate-safety-reporting")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/aggregate-safety-reporting"),
  component: PVOffering,
});

